<template>
	<Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    :title="curRating && curRating.id ? '编辑评级' : '增加评级'"
		width="500">
		<div class="container">
			<Form :model="formData" ref="form" label-position='left' :label-width="100" :rules="ruleValidate">
				<FormItem label="评级分值" prop="number">
					<InputNumber :min="0" v-model="formData.number" placeholder="" />
				</FormItem>
				<FormItem label="评级前缀" prop="prefix">
					<Input v-model="formData.prefix" placeholder="请输入单个大写字母" maxlength="1"/>
				</FormItem>
				<FormItem label="评级描述" prop="description">
					<Input v-model="formData.description" placeholder="请输入评级描述"/>
				</FormItem>
				<FormItem label="自定义名称">
					<span class="custom-name">{{ customName }}</span>
				</FormItem>
				<div class="flex flex-end">
					<Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
					<Button type="primary" @click="submit">确定</Button>
				</div>
			</Form>
		</div>
	</Modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curRating: {
      type: Object,
    }
  },
	data() {
		return {
			formData: {
				prefix: '',
				description: '',
				number: 0,
      },
		}
	},
	computed: {
    ...mapState('setting', [
			'ratings',
    ]),
    // 仅当域名为 bot-designer.zhizeliming.com 时，评级前缀为必填，其余环境非必填
    isPrefixRequired() {
      return window.location.hostname === 'bot-designer.zhizeliming.com';
    },
    ruleValidate() {
      return {
        number: [
          { type: 'number', required: true, message: '评级不能为空', trigger: 'blur' },
          {
            type: 'number',
            validator: (rule, value) => {
              if (this.curRating?.id && value === ~~this.curRating.id) return true;
              const index = Object.keys(this.ratings)?.findIndex(key => ~~key === value);
              return !(index >= 0)
            },
            message: '该评级已经存在'
          }
        ],
        prefix: [
          { required: this.isPrefixRequired, message: '评级前缀不能为空', trigger: 'blur' },
          { pattern: /^[A-Z]$/, message: '评级前缀只能是单个大写字母', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '评级描述不能为空', trigger: 'blur' },
        ],
      };
    },
    customName() {
      const { prefix, description } = this.formData;
      return prefix ? `${prefix}-${description || ''}` : (description || '');
    },
	},
	watch: {
		curRating(val) {
			if (!val) return
      const { prefix, description } = this.parseName(val.name);
      this.formData = { ...val, prefix, description };
		},
    ratings(val) {
      if (this.visible) return;
      this.formData.number = this.getNextNumber();
    },
    'formData.prefix'(val) {
      // 自动把小写转大写；非字母字符保留，交给校验规则提示「只能是单个大写字母」
      const upper = (val || '').toUpperCase();
      if (upper !== val) this.formData.prefix = upper;
    },
	},
	methods: {
    // 解析历史的自定义名称：符合 `${前缀}-${描述}` 格式则拆分，否则整体放入评级描述
    parseName(name) {
      const matched = /^([A-Z])-([\s\S]*)$/.exec(name || '');
      if (matched) {
        return { prefix: matched[1], description: matched[2] };
      }
      return { prefix: '', description: name || '' };
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const { prefix, description, number } = this.formData;
        const name = prefix ? `${prefix}-${description}` : description;
				this.$emit('onSubmit', { ...this.formData, name });
        this.cancelHandler();
      })
    },
		cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
				prefix: '',
				description: '',
				number: this.getNextNumber(),
      }
      this.$emit('change', false)
      this.$emit('onCancel')
    },
    getNextNumber() {
      const nums = Object.keys(this.ratings);
      if (nums.length === 0) return 0;
      const maxNum = Math.max(...nums);
      return maxNum + 1;
    },
	}
}
</script>
<style lang="scss" scoped>
.custom-name {
	color: #515a6e;
	word-break: break-all;
}
</style>